import React, { useLayoutEffect } from 'react';
import './styles.scss';

const CookieModal = ({ style }: { style?: React.CSSProperties }) => {
  const [showModal, setShowModal] = React.useState(false);
  const [cookieInput, setCookieInput] = React.useState(true);
  const [trackingInput, setTrackingInput] = React.useState(true);

  const acceptCookies = () => {
    localStorage.setItem('cookieconsent_status', cookieInput ? 'allow' : 'deny');
    localStorage.setItem('trackingconsent_status', trackingInput ? 'allow' : 'deny');
    if (typeof window !== 'undefined' && window._paq) {
      const params = new URLSearchParams(location.search);
      const ref = params.get('ref');
      window._paq.push(['setCustomDimension', 1, ref]);
      window._paq.push(['setCustomUrl', location.href]);
      window._paq.push(['trackPageView']);
    }
    setShowModal(false);
  };
  const declineCookies = () => {
    localStorage.setItem('cookieconsent_status', 'deny');
    localStorage.setItem('trackingconsent_status', 'deny');
    setShowModal(false);
  };

  const checkCookies = () => {
    const cookieStatus = localStorage.getItem('cookieconsent_status');
    const trackingStatus = localStorage.getItem('trackingconsent_status');
    if (cookieStatus === null || trackingStatus === null) setShowModal(true);
    if (trackingStatus === 'allow') {
      if (window._paq) window._paq.push(['setConsentGiven']);
    }
    if (cookieStatus === 'allow') {
      if (window._paq) window._paq.push(['setCookieConsentGiven']);
    }
  };

  useLayoutEffect(() => {
    checkCookies();
  }, []);

  return (
    <div className="cookieModalWrapper" style={showModal ? style : { display: 'none' }}>
      <div className="cookieModalBackdrop"></div>
      <div className="cookieModalContent">
        <div className="cookieModalText">
          <h1>Nur kurz die Kekse...</h1>
          <p>
            Um unsere Website stetig zu verbessern, verwenden wir das Analyse-Tool Matomo. <br />
            Alle von uns gesammelten Daten werden ausschließlich anonymisiert auf unserem eigenen
            Server gespeichert. <br />
            Wir geben keine Daten an Dritte weiter und wir speichern keine personenbezogenen Daten.
            <br />
            Dennoch möchten wir Ihnen hier die Möglichkeit geben, sowohl dem Sammeln von Daten
            allgemein als auch der Verwendung von Cookies zu widersprechen.
          </p>
        </div>
        <div className="cookieModalOptions">
          Cookies
          <label className="switch">
            <input
              type="checkbox"
              checked={cookieInput}
              onChange={(e) => setCookieInput(e.target.checked)}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="cookieModalOptions">
          Tracking
          <label className="switch">
            <input
              type="checkbox"
              checked={trackingInput}
              onChange={(e) => setTrackingInput(e.target.checked)}
            />
            <span className="slider round"></span>
          </label>
        </div>
        <div className="cookieModalButtons">
          <button id="cookie_decline" onClick={declineCookies}>
            Alles ablehnen
          </button>
          <button id="cookie_accept" onClick={acceptCookies}>
            Einstellungen speichern
          </button>
        </div>
      </div>
    </div>
  );
};
export default CookieModal;
